export { AnchoredLayerBoundariesElement as PopoverBoundariesElement, AnchoredLayerOffset as PopoverLayerOffset, AnchoredLayerPosition as PopoverLayerPosition } from '@doordash/component-layer-manager';

var PopoverInteractionType;

(function (PopoverInteractionType) {
  PopoverInteractionType["ToggleClick"] = "TOGGLE_CLICK";
  PopoverInteractionType["Controlled"] = "CONTROLLED";
})(PopoverInteractionType || (PopoverInteractionType = {}));

var PopoverContentDisplayMode;

(function (PopoverContentDisplayMode) {
  PopoverContentDisplayMode["Flex"] = "flex";
  PopoverContentDisplayMode["InlineFlex"] = "inline-flex";
  PopoverContentDisplayMode["InlineBlock"] = "inline-block";
  PopoverContentDisplayMode["Block"] = "block";
  PopoverContentDisplayMode["Inline"] = "inline";
})(PopoverContentDisplayMode || (PopoverContentDisplayMode = {}));

export { PopoverContentDisplayMode, PopoverInteractionType };
